import axiosInstance from ".";

export const getQuerySchema = async () => {
    return axiosInstance.get("/query-form/schema");
};

export const updateQuerySchema = (data) => {
    return axiosInstance.post("/query-form/schema", data);
};

export const getQueryResponses = async (params) => {
    return axiosInstance.get("/query-form/responses", { params });
};
